import { render, staticRenderFns } from "./Company_recruitments_edition.vue?vue&type=template&id=65dfb606&scoped=true&lang=pug&"
import script from "./Company_recruitments_edition.vue?vue&type=script&lang=coffee&"
export * from "./Company_recruitments_edition.vue?vue&type=script&lang=coffee&"
import style0 from "./Company_recruitments_edition.vue?vue&type=style&index=0&id=65dfb606&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfb606",
  null
  
)

export default component.exports